import React from "react";
import { Anchor, UserMenu } from "discover.medical.react-component-library";
import {
  appendReturnToUrl,
  appendAmplitudeDeviceId,
} from "../../util/userActions";

const Personalized = ({ cta, userDetails }) => {
  return (
    <UserMenu
      data-testid="home-cta-card-personalized"
      fontSize="sm"
      username={userDetails.displayName}
      title={userDetails.affiliationName || "Individual Subscriber"}
      initials={userDetails.initials}
      alert={cta.alert}
    >
      {cta.subscribe && (
        <Anchor
          fontSize="sm"
          fontWeight="bold"
          href={appendAmplitudeDeviceId(appendReturnToUrl(cta.subscribeUrl))}
        >
          {cta.subscribe}
        </Anchor>
      )}
    </UserMenu>
  );
};

export default Personalized;
